import React, { useEffect, useRef } from "react";
import { Container } from "@mui/material";

const BookADemoButton = ({className}) => {
  const embedRef = useRef(null);

  useEffect(() => {
    if (!embedRef.current) return;

    const script = document.createElement("script");
    script.src = "https://embed.ycb.me";
    script.async = true;
    script.dataset.domain = "navneetdwivedi";
    script.dataset.type = "button-link";
    script.dataset.innertext = "Book a Demo";
    script.dataset.buttoncolor = "#1976D2";
    script.dataset.displaymode = "auto";

    embedRef.current.appendChild(script);

    return () => {
      if (embedRef.current && script.parentNode === embedRef.current) {
        embedRef.current.removeChild(script);
      }
    };
  }, []);

  return (
    <main className="book-a-demo-page">
      {/* <Container maxWidth="lg" > */}
        <div
          ref={embedRef}
          className={`book-a-demo-container ${className}`}
        ></div>
      {/* </Container> */}
    </main>
  );
};

export default BookADemoButton;

